import React from "react";
import styles from "./dependency-mapping.module.css";

export const DependencyMappingSkeleton = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {/* Preview image skeleton */}
        <div className={styles.previewImageContainer}>
          <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="159" fill="none" viewBox="0 0 325 159">
            <rect width="100%" height="159" fill="#F8F9FC" rx="12"></rect>
          </svg>
        </div>
      </div>

      <div className={styles.contentContainer}>
        {/* Title skeleton */}
        <div className={styles.selectorsRow}>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "100%" }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="240" height="16" fill="none" viewBox="0 0 240 16">
              <rect width="240" height="16" fill="#EBEDF3" rx="6"></rect>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="280" height="12" fill="none" viewBox="0 0 280 12">
              <rect width="280" height="12" fill="#EBEDF3" rx="6"></rect>
            </svg>
          </div>
        </div>

        {/* Board selectors skeleton */}
        <div className={styles.selectorsRow}>
          <svg xmlns="http://www.w3.org/2000/svg" width="156" height="28" fill="none" viewBox="0 0 156 28">
            <rect width="156" height="28" fill="#EBEDF3" rx="6"></rect>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" width="156" height="28" fill="none" viewBox="0 0 156 28">
            <rect width="156" height="28" fill="#EBEDF3" rx="6"></rect>
          </svg>
        </div>
      </div>
    </div>
  );
};
